// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"0504557a","128":"0504557a","316":"0504557a","318":"0504557a","353":"0b992348","397":"4b566732","484":"0504557a","527":"0504557a","553":"0504557a","604":"0a177bf4","698":"0504557a","728":"0504557a","995":"351d0659"}[chunkId] + ".chunk.css";
};